import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import FormComponent from '../FormComponent';
import SearchInputField from '../SearchInputField';
import { InputTypes } from '../../utils/validateFormElement';
import ParkAddressSearch from '../ParkAddressSearch';

const CLICK_EVENT = 'click';

const HIDDEN_CLASS = 'u-hidden';

class ParkFinder extends FormComponent {
	// eslint-disable-next-line no-useless-constructor
	constructor(element, config) {
		super(element, config);
	}
	markup(value, rowData, titleMarkup) {
		return `
            <div class="lta-park-finder u-mb-5">
				<div class="lta-park-finder-title u-hidden">${titleMarkup}</div>
                <div class="lta-park-finder--search-input-wrapper">
					<div class="lta-park-finder--search-input u-mb-2"></div>
					<div class="lta-park-finder--search-form-button-wrapper u-flex">
						<button type="button" class="lta-park-finder--search-form-button lta-btn lta-btn--lg lta-btn--link">Can’t find your ${rowData.venueType}? Enter it manually</button>
					</div>
				</div>
				<div class="lta-park-finder--search-result u-hidden"></div>
				<div class="lta-park-finder--search-form u-hidden">
					<div class="lta-park-finder--search-form-wrapper"></div>
					<div class="lta-park-finder--search-form-button-wrapper u-flex">
						<button type="button" class="lta-park-finder--address-form-button lta-btn lta-btn--lg lta-btn--link">Use ${rowData.venueType} look-up search</button>
					</div>
				</div>
            </div>
        `;
	}
	afterRender() {
		this.parkFinderElement = SelectorEngine.findOne('.lta-park-finder', this.containerEl);
		this.parkFinderTitle = SelectorEngine.findOne('.lta-park-finder-title', this.parkFinderElement);
		this.parkFinderSearchInputWrapper = SelectorEngine.findOne(
			'.lta-park-finder--search-input-wrapper',
			this.parkFinderElement
		);
		this.parkFinderSearchInput = SelectorEngine.findOne(
			'.lta-park-finder--search-input',
			this.parkFinderSearchInputWrapper
		);
		this.parkFinderSearchFormButton = SelectorEngine.findOne(
			'.lta-park-finder--search-form-button',
			this.parkFinderSearchInputWrapper
		);
		this.parkFinderSearchResult = SelectorEngine.findOne('.lta-park-finder--search-result', this.parkFinderElement);
		this.parkFinderSearchForm = SelectorEngine.findOne('.lta-park-finder--search-form', this.parkFinderElement);
		this.parkFinderSearchFormWrapper = SelectorEngine.findOne(
			'.lta-park-finder--search-form-wrapper',
			this.parkFinderSearchForm
		);
		this.parkFinderAddressButton = SelectorEngine.findOne(
			'.lta-park-finder--address-form-button',
			this.parkFinderSearchForm
		);

		this.defaultTitleMarkup = this.parkFinderTitle.innerHTML;
		this.isManualEntryMode = false;

		this.initSearchInputField();

		if (this.data?.value) {
			// Small delay to ensure search input is initialized
			setTimeout(() => {
				this.loadParkResult(this.data.value, true);
			}, 0);
		}

		EventHandler.on(this.parkFinderSearchFormButton, CLICK_EVENT, () => {
			this.showManualEntryView();
		});

		EventHandler.on(this.parkFinderAddressButton, CLICK_EVENT, () => {
			this.showSearchView();
		});
	}
	showManualEntryView() {
		this.isManualEntryMode = true;
		this.value = undefined;
		this.searchInputTextField.remove();
		this.parkFinderSearchInputWrapper.classList.add(HIDDEN_CLASS);
		this.parkFinderSearchResult.classList.add(HIDDEN_CLASS);
		this.parkFinderSearchForm.classList.remove(HIDDEN_CLASS);
		this.parkFinderTitle.classList.remove(HIDDEN_CLASS);

		if (this.data?.manualEntryTitle) {
			this.parkFinderTitle.innerHTML = `<div class="u-mb-5 sm:u-mb-3 lta-heading-title">${this.data.manualEntryTitle}</div>`;
		}

		this.parkAddressSearch = new ParkAddressSearch(this.parkFinderSearchFormWrapper, {
			data: {
				...this.data.addressFormElement,
				instructionText: this.data?.instructionText,
				manualEntryNote: this.data?.manualEntryNote,
				onReturnToSearch: () => this.showSearchView()
			}
		});
		this.parkAddressSearch.onChange((value) => {
			this.setupValueObject(value, 'Partially Completed');
		});

		if (this.data?.onManualEntryModeChange) {
			this.data.onManualEntryModeChange(true);
		}
	}
	showSearchView() {
		this.isManualEntryMode = false;
		this.value = undefined;
		this.parkAddressSearch?.remove();
		this.parkAddressSearch = null;
		this.initSearchInputField();
		this.parkFinderSearchInputWrapper.classList.remove(HIDDEN_CLASS);
		this.parkFinderSearchResult.classList.add(HIDDEN_CLASS);
		this.parkFinderSearchForm.classList.add(HIDDEN_CLASS);
		this.parkFinderTitle.classList.add(HIDDEN_CLASS);

		if (this.data?.manualEntryTitle) {
			this.parkFinderTitle.innerHTML = this.defaultTitleMarkup;
		}

		if (this.data?.onManualEntryModeChange) {
			this.data.onManualEntryModeChange(false);
		}
	}
	initSearchInputField() {
		this.searchInputTextField = new SearchInputField(this.parkFinderSearchInput, {
			data: this.data
		});
		this.searchInputTextField.dataMapping = (item) => {
			return {
				firstLineText: item.venueName,
				secondLineText: `${item.county}, ${item.postcode}`,
				dataKey: this.data.dataKey,
				dataValue: item.id
			};
		};
		this.searchInputTextField.filterDataMapping = (item, event) => {
			return item.id === event[this.data.dataKey];
		};
		this.searchInputTextField.searchInputMappingChange();
		this.searchInputTextField.onChange((event) => {
			this.loadParkResult(event.value, true);
		});
		this.setupValidateObject();
		if (this.data?.value) {
			this.loadParkResult(this.data?.value, false);
		}
	}
	loadParkResult(resultDetails, isSetupValueObject) {
		if (isSetupValueObject) {
			this.setupValueObject(resultDetails, 'Complete');
		}
		if (!resultDetails?.venueName) {
			return;
		}
		this.parkFinderSearchInputWrapper.classList.add(HIDDEN_CLASS);
		this.parkFinderSearchForm.classList.add(HIDDEN_CLASS);
		this.parkFinderTitle.classList.remove(HIDDEN_CLASS);
		this.parkFinderSearchResult.classList.remove(HIDDEN_CLASS);

		this.parkFinderSearchResult.innerHTML = '';

		this.parkFinderSearchResult.insertAdjacentHTML('beforeend', this.renderAutoSuggestResult(resultDetails));
		this.afterAutoSuggestResultRender();
	}
	setupValueObject(value, obBoardingStatus) {
		this.value = {
			...this.data,
			value: value
				? {
						...value,
						onboardingStatus: obBoardingStatus
				  }
				: undefined
		};
		if (this.value) {
			this.dependentQuestion = this.value.dependentQuestion;
		}
	}
	afterAutoSuggestResultRender() {
		const suggestionAutoSuggestResult = SelectorEngine.findOne(
			'.lta-autosuggest-input-result',
			this.parkFinderSearchResult
		);
		const searchAgainButton = SelectorEngine.findOne('.lta-park-search--again', suggestionAutoSuggestResult);

		EventHandler.on(searchAgainButton, CLICK_EVENT, () => {
			this.value = undefined;
			suggestionAutoSuggestResult.remove();
			this.searchInputTextField.remove();
			this.initSearchInputField();
			this.parkFinderSearchInputWrapper.classList.remove(HIDDEN_CLASS);
			this.parkFinderTitle.classList.add(HIDDEN_CLASS);
			this.parkFinderSearchForm.classList.add(HIDDEN_CLASS);
			this.parkFinderSearchResult.classList.add(HIDDEN_CLASS);
		});
	}
	renderAutoSuggestResult(parkDetail) {
		return `<div class="lta-autosuggest-input-result u-mb-4">
					<div class="u-mb-4">
						${this.renderInstructionLabel(this.data.instructionText)}
					</div>
					${!this.data?.resultTitleNotVisible ? `<div class="lta-text-input__label">Your ${this.data.venueType}</div>` : ''}
					<div class="u-px-3 u-py-2 u-bg-background-blue u-rounded">
						<div class="lta-autosuggest-input-result_park-name u-h6 u-mb-1">${parkDetail.venueName}</div>
						<div class="u-body2 u-mb-2">
							<br>${parkDetail.county}
							<br>${parkDetail.postcode}
						</div>
						<button type="button" class="lta-btn lta-btn--xs lta-btn--petite lta-btn--icon lta-btn--icon-before lta-park-search--again">
							<svg class="lta-icon js-lta-text-input--btn-icon u-mr-1" width="1.5em" height="1.5em" fill="currentColor" alt="search" aria-hidden="true">
								<use xlink:href="/static/images/icons/lta-icons.svg#close"></use>
							</svg>Remove ${this.data.venueType}
						</button>
					<div>
				</div>`;
	}
	renderInstructionLabel(instructionLabel) {
		return instructionLabel ? `<span class="lta-text-input__label-instruction">${instructionLabel}</span>` : '';
	}
	setupValidateObject() {
		this.formElementData = {
			element: this.searchInputFieldContainerElement,
			formElement: this.searchInputFieldElement,
			errorMessage: this.data.errorMessage,
			inputType: InputTypes.SELECTOR_INPUT,
			hasIcon: false
		};
	}
	validate() {
		if (this.isManualEntryMode) {
			return this.parkAddressSearch ? this.parkAddressSearch.validate() !== false : false;
		}

		return this.searchInputTextField?.validate(true) !== false;
	}
}
export default ParkFinder;
